@if (modelList.length === 0) {
    <p class="empty">There are no models yet. Use Create model above to add your first one.</p>
}@else if (compact) {
    <div class="compact-list" data-testid="model-list-compact">
        @for (row of data; track row._key) {
            <button type="button" class="compact-row" (click)="openModel(row)">
                <app-node-svg [settings]="row.settings"/>
                <span class="compact-name">
                    <span>{{row.name}}</span>
                    @if (row.functionName) {
                        <span class="compact-sub">{{row.functionName}}</span>
                    }
                </span>
                <span class="compact-figures">
                    <span>{{row.hours | number:'1.0-0'}} h</span>
                    <span class="compact-sub">{{row.cost | currency:currencyCode:'symbol-narrow':'1.0-0'}}</span>
                </span>
            </button>
        }
    </div>
}@else {
    <div class="controls-container">
        @if (project) {
            <mat-slide-toggle labelPosition="after" [(ngModel)]="filterChangedModels" (change)="toggleChangedModelsFilter()" matTooltip="Only show models that have been changed in this project">Only changed models</mat-slide-toggle>
        }@else {
            <span></span>
        }
        <button mat-button color="accent" [matMenuTriggerFor]="columnMenu" matTooltip="Choose which columns to show" data-testid="model-columns-button">
            <mat-icon>view_column</mat-icon>Columns
        </button>
        <mat-menu #columnMenu="matMenu">
            @for (column of optionalColumns; track column.name) {
                <div mat-menu-item (click)="$event.stopPropagation(); toggleColumn(column)">
                    <mat-checkbox [checked]="isColumnVisible(column)" (click)="$event.stopPropagation()" (change)="toggleColumn(column)">{{column.header}}</mat-checkbox>
                </div>
            }
            <button mat-menu-item (click)="resetColumns()">Reset to default</button>
        </mat-menu>
    </div>
    @if (organisation) {
        <app-table [columns]="columns" [data]="data" [rowSelect]="true" [filter]="true" [height]="600" (rowEvent)="handleRowEvent($event)"></app-table>
    }
}
